import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";

export class ExpandAnimation extends PIXI.Sprite {
    private _updated: boolean = false;
    private _meltAnimation: TimelineSprite;
    private _fireAnimation: TimelineSprite;
    private _commonOverlay: TimelineSprite;
    private _isMayHemMode: boolean = false;

    constructor() {
        super();
        this.anchor.set(0.5, 0.5);
    }

    public setMayHemMode(isMayhem: boolean): void {
        this._isMayHemMode = isMayhem;
    }

    public initOverLayAnimations() {
        this._meltAnimation = this.createTimelineSprite("revealAnimationX2_5");
    }

    public meltAnimation(mSize: number, symHeight: number, reelSize: number, infectious: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this.setMeltAnimation(infectious, mSize, reelSize);
        this._fireAnimation = this.createTimelineSprite("fire", undefined, PIXI.BLEND_MODES.ADD);
        this._commonOverlay = this.createTimelineSprite("commonOverlay", undefined, PIXI.BLEND_MODES.ADD);
        this._fireAnimation.anchor.set(0.5, 0);
        this._commonOverlay.anchor.set(0.5, 0.5);
        this._fireAnimation.y = -((symHeight * mSize) / 2);
        this._fireAnimation.scale.set(1, 0.08);
        tl.add(() => {
            this._fireAnimation.show();
            TweenLite.to(this._fireAnimation.scale, 0.2, {y: 0.5});
            TweenLite.to(this._fireAnimation, 0.2, {y: -((symHeight * mSize) / 2) - 17});
            TweenLite.to(this._fireAnimation, 0.5, {alpha: 1});
            if (this._isMayHemMode) {
                this.playOverlayAnimation();
            }
        }, 0);
        tl.add(() => {
            this._fireAnimation.getAnimation();
            //#335
            if (!this._isMayHemMode) {
                this._meltAnimation.getAnimationAutoShowHide();
            }
        }, 0.1);
        tl.add(() => {
            if (!this._isMayHemMode) {
                this.playOverlayAnimation();
            }
        }, 0.267);
        tl.add(() => {
            TweenLite.to(this._fireAnimation, 0.5, {alpha: 0});
        }, 0.5);
        tl.add(() => {
            this.removeChild(this._fireAnimation, this._commonOverlay, this._meltAnimation)
        }, 1);
        return tl;
    }

    public reset(): void {
        this.visible = false;
        this.scale.set(1, 1);
        this._updated = false;
    }

    private playOverlayAnimation() {
        this._commonOverlay.tint = 0x96FF00;
        TweenLite.to(this._commonOverlay, 0.2, {y: -30});
        this._commonOverlay.getAnimationAutoShowHide().timeScale(2);
    }

    private setMeltAnimation(infectious: boolean, mSize: number, reelSize: number): void {
        if (this._meltAnimation) {
            this._meltAnimation.destroy();
        }
        if (infectious) {
            this._meltAnimation = this.createTimelineSprite("revealInfAnimX" + mSize + "_" + reelSize);
        } else {
            this._meltAnimation = this.createTimelineSprite("revealAnimationX" + mSize + "_" + reelSize);
        }
        if (mSize == 2) {
            this._meltAnimation.y = 2;
        } else {
            this._meltAnimation.y = 2;
        }
        this._meltAnimation.anchor.set(0.5);
    }

    private createTimelineSprite(resourceName: string, fps?: number, mode?: PIXI.BLEND_MODES): TimelineSprite {
        if (!fps) fps = 30;
        const sprite: TimelineSprite = new TimelineSprite(GameResources.getTextures(resourceName), fps);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(0, 0);
        if (mode) {
            sprite.blendMode = mode;
        }
        this.addChild(sprite);
        sprite.hide();
        sprite.name = resourceName;
        return sprite;
    }
}